// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e27d8122","453":"cff9133f","732":"87e1d8f7"}[chunkId] + ".chunk.js";
};